import { render } from "./AdvancedPortfolio.vue?vue&type=template&id=35266642"
import script from "./AdvancedPortfolio.vue?vue&type=script&lang=js"
export * from "./AdvancedPortfolio.vue?vue&type=script&lang=js"

import "./AdvancedPortfolio.vue?vue&type=style&index=0&id=35266642&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__